import { combineReducers } from 'redux';

import { passengersReducer, PassengersState } from './passengers/reducers';
import { segmentsReducer, SegmentsState } from './segments/reducers';
import { redeemMilesReducer } from './redeemMiles/reducers';
import { Voucher } from '../../Voucher/types';
import { vouchersReducer } from './vouchers/reducers';
import { recentSearchesReducer } from './recentSearches/reducers';
import { Location } from '../../LocationAutocomplete/types';
import { PromoCodeState } from './promoCode/reducers';
import promoCodeReducer from './promoCode/reducers';
import { selectedFareGroupReducer } from './fareGroup/reducers';
import { PassengerConfigState, passengersConfigReducer } from './passengersConfig/reducers';
import { offerHotelsReducer } from './offerHotels/reducers';
import foreignCardReducer from './foreignCard/reducer';

export interface SearchFormState {
	segments: SegmentsState;
	passengers: PassengersState;
	passengersConfig: PassengerConfigState;
	selectedFareGroup?: string;
	redeemMiles: boolean;
	voucher: Voucher;
	recentSearches: Location[];
	promoCode: PromoCodeState;
	offerHotels: boolean;
	foreignCard: boolean; // WEBSKY-4967
}

export const rootReducer = combineReducers<SearchFormState>({
	segments: segmentsReducer,
	passengers: passengersReducer,
	passengersConfig: passengersConfigReducer,
	selectedFareGroup: selectedFareGroupReducer,
	redeemMiles: redeemMilesReducer,
	voucher: vouchersReducer,
	recentSearches: recentSearchesReducer,
	promoCode: promoCodeReducer,
	offerHotels: offerHotelsReducer,
	foreignCard: foreignCardReducer
});
